module.exports = __webpack_public_path__ + "img/ps-21.d78e2e74.jpg";